import { apiClient } from "../api";
import { CreateProjectDto, Project, UpdateProjectDto } from "../generated/client";

export const createProject = async (data: CreateProjectDto): Promise<Project> => {
    try {
        const response = await apiClient.projects.create(data);
        return response.data;
    } catch (error) {
        console.error("create project:", error);
        throw error;
    }
};

export const getAllProjects = async (): Promise<Array<Project>> => {
    try {
        const response = await apiClient.projects.findAll();
        return response.data;
    } catch (error) {
        console.error("fetch projects:", error);
        throw error;
    }
};

export const getProjectById = async (id: string): Promise<Project> => {
    try {
        const response = await apiClient.projects.findOne(id);
        return response.data;
    } catch (error) {
        console.error(`fetch project by ID ${id}:`, error);
        throw error;
    }
};

export const updateProject = async (id: string, data: UpdateProjectDto): Promise<Project> => {
    try {
        const response = await apiClient.projects.update(id, data);
        return response.data;
    } catch (error) {
        console.error(`update project by ID ${id}:`, error);
        throw error;
    }
};

export const removeProject = async (id: string): Promise<void> => {
    try {
        await apiClient.projects.remove(id);
    } catch (error) {
        console.error(`removing project by ID ${id}:`, error);
        throw error;
    }
};
